<template>
  <div class="table-crud-modal" ref="editVideoModal">
    <h2 class="lvl2-heading">Editer la vidéo</h2>
    <el-form :model="params" label-position="left" :status-icon="true">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="title">
            <span>Titre:*</span>
            <el-input v-model="params.title" placeholder="Titre"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="status">
            <span>Status:</span>
            <el-input
              readonly
              v-model="params.status"
              placeholder="Status"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="media">
            <span>Vidéo:*</span>
            <FileUpload
              name="media-upload"
              :error="mediaEmpty"
              :placeholder="
                typeof params.media == 'string' ? params.media : 'Média'
              "
              :acceptedTypes="['video/mp4']"
              :upload="params.media == null"
              @file-upload="params.media = $event"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="thumbnail">
            <span>Thumbnail:*</span>
            <FileUpload
              name="thumbnail-upload"
              :placeholder="
                typeof params.thumbnail == 'string' ? params.thumbnail : 'Média'
              "
              :error="thumbnailEmpty"
              :acceptedTypes="['image/png', 'image/jpeg', 'image/jpg']"
              :upload="params.thumbnail == null"
              @file-upload="params.thumbnail = $event"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-form-item prop="description">
          <span>Description:</span>
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="params.description"
            placeholder="description"
          ></el-input>
        </el-form-item>
      </el-row>

      <el-form-item style="text-align: right">
        <base-button @click.prevent.stop.native="handleSubmit" :fluid="false"
          >Modifier</base-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Input, Form, FormItem, Message, Row, Col } from "element-ui"
import { mapState } from "vuex"
import FileUpload from "@/components/FileUpload.vue"
import { updateSponsoredVideo } from "@/api/videos"
import { fetchUsers } from "@/api/users"
// import Checkbox from "@/components/Checkbox_Improved"
import { mapGetters } from "vuex"
import { emitter } from "@/utils"
import { loaderMixin } from "@/mixins"
export default {
  components: {
    ElInput: Input,
    ElFormItem: FormItem,
    ElForm: Form,
    ElRow: Row,
    ElCol: Col,
    FileUpload
  },
  mixins: [loaderMixin],
  data() {
    return {
      params: {
        theme_id: null,
        type_supports: null,
        brand_id: null,
        title: null,
        media: null,
        thumbnail: null,
        freelancer_id: null,
        status: "created",
        competitor_price: 0,
        ean: "",
        description: "",
        trending: 0
      },
      freelancers: [],
      statuses: [
        { label: "Créée", value: "created" },
        { label: "Validée", value: "approved" },
        { label: "Vérifiée", value: "verified" },
        { label: "Désactivée", value: "deactivated" }
      ],
      mediaEmpty: false,
      thumbnailEmpty: false
    }
  },
  computed: {
    ...mapGetters(["modal"]),
    ...mapState({
      supportstypes: state => state.supportstypes,
      marques: state => state.marques,
      thematiques: state => state.thematiques
    })
  },
  methods: {
    handleSubmit() {
      const { media, thumbnail, ...params } = this.params

      if (!media) {
        this.mediaEmpty = true
        return
      }
      if (!thumbnail) {
        this.thumbnailEmpty = true
        return
      }
      this.openLoader(this.$refs.editVideoModal)

      const formData = new FormData()
      formData.append("media", media)
      if (thumbnail) formData.append("thumbnail", thumbnail)
      updateSponsoredVideo(this.modal.payload.video.id, params, formData)
        .then(() => {
          Message.success("Vidéo editée")
          emitter.$emit("update-sponsored-videos-table")
          this.closeLoader()
          this.$store.dispatch("closeModal")
        })
        .catch(() => {
          this.closeLoader()
          // Message.error("Vidéo n'est pas edité")
        })
    },
    handleCompetitorPriceChange() {
      this.params.competitor_price = this.params.competitor_price
        .replace(/,/g, ".")
        .toString()
    }
  },
  created() {
    this.$store.dispatch("getSupportsTypes")
    fetchUsers().then(({ data }) => {
      //only get freelancers
      this.freelancers = data.filter(u => u.role === "freelancer")
    })
    this.params = Object.assign({}, this.params)
    const video = this.modal.payload.video
    for (const key in this.params) {
      if (video.hasOwnProperty(key)) {
        this.params[key] = video[key]
      }
    }
  },
  mounted() {
    this.params.type_supports = this.modal.payload.video.type_supports.map(
      type => type.id
    )
  }
}
</script>
